module.exports = __webpack_public_path__ + "img/bg.6f83b489.jpg";